import {CreateBundleActions, CreateBundleState, CreateBundleSteps} from "./types";

export const initialCreateBundleState: CreateBundleState = {
  currentCreateBundleStep: "basicForm",
  formData: {
    bookingQuestions: [],
    callDuration: "15",
    callLocation: "video",
    callPrice: 100,
    callPriceCurrency: "NGN",
    callPriceType: "paid",
    currencies: [],
    customCallDuration: undefined,
    description: "",
    hideFromProfile: false,
    // isPaused: false,
    isUrlRedirect: false,
    redirectAfterPurchase: "none",
    telegramGroupId: undefined,
    name: "",
    requestCustomerPhoneNumber: false,
    slug: "",
    url_redirect: undefined,
    coverImage: null,
    bookingInterval: "1day",
    numberOfSessions: "",
    availabilityScheduleId: "",
  },
  apiResponseData: null,
};

export const createBundleReducer = (
  state: CreateBundleState = initialCreateBundleState,
  action: CreateBundleActions
) => {
  if (action.type === "update-create-bundle-form-step") {
    const yo = {...state, currentCreateBundleStep: action.payload};
    return yo;
  }
  if (action.type === "go-to-basic-form-step") {
    const yo = {
      ...state,
      currentCreateBundleStep: "basicForm" as CreateBundleSteps,
      formData: {
        ...state.formData,
        ...action.payload,
      },
    };
    return yo;
  }
  if (action.type === "go-to-checkout-form-step") {
    const yo = {
      ...state,
      currentCreateBundleStep: "checkoutForm" as CreateBundleSteps,
      formData: {
        ...state.formData,
        ...action.payload,
      },
    };
    return yo;
  }
  if (action.type === "go-to-cover-images-upload-form-step") {
    const yo = {
      ...state,
      currentCreateBundleStep: "coverImagesUpload" as CreateBundleSteps,
      formData: {
        ...state.formData,
        ...action.payload.formData,
      },
      apiResponseData: action.payload.apiResponse,
    };
    return yo;
  }
  if (action.type === "save-create-bundle-form-values") {
    return {
      ...state,
      formData: {
        ...state.formData,
        ...action.payload,
      },
    };
  }
  if (action.type === "reset-state") {
    const yo = {...initialCreateBundleState};
    return yo;
  }

  return state;
};
